'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var settingsFix = {
    settingsBackup: null,
    backupSettings: function backupSettings() {
        settingsFix.settingsBackup = document.querySelector('input[type=hidden]#settings');
        return settingsFix.settingsBackup;
    },
    restoreSettingsElement: function restoreSettingsElement(element) {
        element = element || settingsFix.settingsBackup;
        // check if element is not already present
        if (!element || document.getElementById(element.id)) return;
        document.body.appendChild(element);
    }
};

exports.default = settingsFix;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settingsFix.js
// module id = 577
// module chunks = 0 1